import { CALENDAR_CLOUD_SETTINGS_BASE_URL } from '../constants';
import { CalendarCloudSettingScopeType } from '../store/schema/CalendarCloudSettingRequestEnums';

/**
 * Gets the URL for a cloud setting
 * @param settingName
 */
export default function getCalendarCloudSettingUrl(settingName: string): string {
    return `${CALENDAR_CLOUD_SETTINGS_BASE_URL}${CalendarCloudSettingScopeType.Global}?settingname=${settingName}`;
}
